import instance from "services";

export default async function GetToken(data: any) {
  const response = await instance.post('/v1/identity/connect/token', {...data})
  return response
}
